<template>
  <section class="content-plans-register">
    <Breadcrumb :links="links" :data="this.dataProps"/>
    <form class="content-plans-register-form" @submit.prevent="handleSubmit()">
      <div class="row">
        <div class="col-12 col-lg-6">
          <div class="content-input-default">
            <input type="text" name="name" v-model="narration.name" value="" placeholder="Nome" required/>
          </div>
        </div>
        <div class="col-12">
          <button class="btn-green">Salvar</button>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
import Breadcrumb from '@/components/breadcrumb/Index';
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      links: [
        {
          name: 'Meditação',
          routerName: 'Meditation'
        },
        {
          name: 'Nova Narração',
          routerName: 'RegisterNarration'
        },
      ],
      narration: {
        id_user: "",
        name: '',
      },
      narrationParams: this.$route.params,
      dataProps: { module: 'Meditation' },
    }
  },
  computed: {
    ...mapGetters({
      user: 'User/user',
      narrationData: 'Meditation/narrations',
    })
  },
  components: {
    Breadcrumb,
  },
  methods: {
    ...mapActions('Meditation', ['registerNarration', 'consultNarrations', 'setDataDefault']),
    async handleSubmit(){
      let message = this.narration?.id ? 'Narração editado com sucesso!' : 'Narração cadastrado com sucesso!';

      await this.registerNarration(this.narration);
      this.$router.push({ name: 'Meditation' })
      this.$swal.fire({
        icon: 'success',
        html: message,
      })
    },
  },
  async mounted() {
    this.narration.id_user = await this.user.id;
    if (this.narrationParams && Object.keys(this.narrationParams).length > 0) {
      await this.consultNarrations(this.narrationParams);
      this.dataProps = { name: 'Meditação', id: this.narrationParams.id, module: 'Meditation' };
      this.narration = this.narrationData;
      this.links[1].name = this.narration.name;
    }
  }
}
</script>

<style lang="scss" scoped>
.content-plans-register {
  padding-bottom: 50px;
}
.content-input-default {
  textarea {
    min-height: 250px;
  }
}
.btn-green {
  margin-top: 100px;
  @media (max-width: 991px){
    margin-top: 50px;
  }
}
</style>
